import type { FccWaypointAction } from '@backoffice-frontend/graphql'
import { FccWaypointHubReturnReason } from '@backoffice-frontend/graphql'
import { useTranslation } from 'react-i18next'

export const usePoolingReasonTranslations = () => {
  const { t } = useTranslation()

  return (key: string) => {
    const map: Record<string, string> = {
      AT_HUB: t('fleetMap_options_poolingReasonAtHub_label'),
      AUTOMATED_PLANNED_BREAK_END: t(
        'fleetMap_options_poolingReasonAutomatedPlannedBreakEnd_label',
      ),
      AUTOMATED_PLANNED_BREAK_START: t(
        'fleetMap_options_poolingReasonAutomatedPlannedBreakStart_label',
      ),
      AUTOMATED_PLANNED_HUB_RETURN: t(
        'fleetMap_options_poolingReasonAutomatedPlannedHubReturn_label',
      ),
      AUTOMATED_SHIFT_END: t(
        'fleetMap_options_poolingReasonAutomatedShiftEnd_label',
      ),
      AUTOMATED_SHIFT_START: t(
        'fleetMap_options_poolingReasonAutomatedShiftStart_label',
      ),
      AUTOMATED_SHORT_BREAK_END: t(
        'fleetMap_options_poolingReasonAutomatedShortBreakEnd_label',
      ),
      AUTOMATED_SHORT_BREAK_START: t(
        'fleetMap_options_poolingReasonAutomatedShortBreakStart_label',
      ),
      CONFIRMED_BY_HUB: t('fleetMap_options_poolingReasonConfirmedByHub_label'),
      EVENT_MODE_START: t('fleetMap_options_poolingReasonEventModeStart_label'),
      MANUAL_INCIDENT_HANDLING: t(
        'fleetMap_options_poolingReasonManualIncidentHandling_label',
      ),
      MANUAL_OTHER: t('fleetMap_options_poolingReasonManualOther_label'),
      MANUAL_SHORT_BREAK: t(
        'fleetMap_options_poolingReasonManualShortBreak_label',
      ),
      MANUAL_TEST_DRIVE: t(
        'fleetMap_options_poolingReasonManualTestDrive_label',
      ),
      MANUAL_TROUBLESHOOTING: t(
        'fleetMap_options_poolingReasonManualTroubleshooting_label',
      ),
      PLANNED_BREAK: t('fleetMap_options_poolingReasonPlannedBreak_label'),
      SERVICE_DISABLED: t(
        'fleetMap_options_poolingReasonServiceDisabled_label',
      ),
      SHIFT_END: t('fleetMap_options_poolingReasonShiftEnd_label'),
      SHORT_BREAK: t('fleetMap_options_poolingReasonShortBreak_label'),
      UNKNOWN: t('fleetMap_options_poolingReasonUnknown_label'),
    }
    return map[key] ?? key
  }
}

export const useDestinationLabelFromWaypointAction = () => {
  const { t } = useTranslation()

  return (key: FccWaypointAction['__typename']) => {
    if (!key) return ''

    const map: Record<string, string> = {
      FccWaypointPickupAction: t('common_pickUp_label'),
      FccWaypointDeliveryAction: t('common_dropOff_label'),
      FccWaypointReallocationAction: t('fleetMap_rebalancingZone_label'),
      FccWaypointHubReturnAction: t('fleetMap_hubReturn_label'),
    }
    return map[key]
  }
}

export const useDestinationLabelFromHubReturnReason = () => {
  const { t } = useTranslation()

  return (key: FccWaypointHubReturnReason) => {
    const map: Record<FccWaypointHubReturnReason, string> = {
      [FccWaypointHubReturnReason.DriverBreak]: t(
        'fleetMap_options_hubReturnReasonDriverBreak_label',
      ),
      [FccWaypointHubReturnReason.ShortBreak]: t(
        'fleetMap_options_hubReturnReasonShortBreak_label',
      ),
      [FccWaypointHubReturnReason.ShiftEnd]: t(
        'fleetMap_options_hubReturnReasonShiftEnd_label',
      ),
      [FccWaypointHubReturnReason.OnDemand]: t(
        'fleetMap_options_hubReturnReasonOnDemand_label',
      ),
    }
    return map[key]
  }
}
